import client from './client';

export interface ExpenseLine {
  id: number;
  report_id: number;
  category: string;
  category_label: string;
  description: string;
  amount: number;
  expense_date: string;
  has_receipt: boolean;
  receipt_filename?: string | null;
}

export interface ExpenseReport {
  id: number;
  company_id: number;
  user_id: number;
  employee_id?: number | null;
  title: string;
  total_amount: number;
  status: 'pending' | 'approved' | 'rejected' | 'cancelled';
  status_label: string;
  comment?: string | null;
  rh_comment?: string | null;
  reviewed_by?: number | null;
  reviewed_at?: string | null;
  created_at: string;
  user_name?: string | null;
  user_email?: string | null;
  employee_name?: string | null;
  lines_count: number;
  lines?: ExpenseLine[];
}

export interface ExpenseLineInput {
  category: string;
  description: string;
  amount: number;
  expense_date: string;
}

export const expenseReportsApi = {
  listMine: () =>
    client.get<{ success: boolean; data: { reports: ExpenseReport[] } }>('/expense-reports/me'),

  list: (params?: { status?: string; page?: number; per_page?: number }) =>
    client.get<{
      success: boolean;
      data: {
        reports: ExpenseReport[];
        pending_count?: number;
      };
    }>('/expense-reports', { params }),

  create: (data: { title?: string; comment?: string; lines: ExpenseLineInput[] }) =>
    client.post<{ success: boolean; data: ExpenseReport; message?: string }>(
      '/expense-reports',
      data,
    ),

  createWithReceipts: (formData: FormData) =>
    client.post<{ success: boolean; data: ExpenseReport; message?: string }>(
      '/expense-reports',
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } },
    ),

  cancel: (id: number) =>
    client.post<{ success: boolean; data: ExpenseReport; message?: string }>(
      `/expense-reports/${id}/cancel`,
    ),

  review: (id: number, data: { action: 'approve' | 'reject'; rh_comment?: string }) =>
    client.post<{ success: boolean; data: ExpenseReport; message?: string }>(
      `/expense-reports/${id}/review`,
      data,
    ),

  downloadReceipt: (reportId: number, lineId: number) =>
    client.get(`/expense-reports/${reportId}/lines/${lineId}/receipt`, {
      responseType: 'blob',
    }),

  meta: () =>
    client.get<{
      success: boolean;
      data: { categories: { value: string; label: string }[] };
    }>('/expense-reports/meta'),
};
